import React from "react";
import { css } from "glamor";

const styles = {
    contentWrapper: css({
        margin: "3rem 50px",
    }),
};

const ContentWithHeader = ({ header, content, nomargin }) => (
    <div>
        {header}
        <div className={nomargin ? "" : styles.contentWrapper}>{content}</div>
    </div>
);

export default ContentWithHeader;
